import request from '@/utils/request'

// 查询短信套餐配置列表(无需登录)
export function fetchPackageList(query) {
  return request({
    url: '/extra/sms/plan/w',
    method: 'get',
    params: query,
  })
}
